import React from 'react';
import { connect } from 'react-redux';
import {
  LocalForm,
  Control,
  actions
} from 'react-redux-form';
import { Redirect } from 'react-router-dom'
import Loading from './Loading';
import {
  create_project,
  reset_report_errors
 } from '../actions'
import Errors from './Errors'
import {
  is_logged_on,
  is_validating
 } from "../helpers"

const { toast } = window.M
const mapStateToProps = state => {
  return {
    // form: state.forms.login,
    mustRedirect: state.report.mustRedirect,
    report: state.report.report,
    errors: state.report.errors
  };
}

const mapDispatchToProps = dispatch => {
  return {
    createProject: values => dispatch(create_project(values)),
    resetForm: () => dispatch( actions.reset('newProject') ),
    resetErrors: () => dispatch ( reset_report_errors() )
  };
}

class ConnectedNewProject extends React.Component {
  constructor() {
    super()
    this.state = {
      report_file: '',
      file: null,
    }
  }

  attachDispatch(dispatch) {
    this.formDispatch = dispatch
  }

  handleUpdate(form) {
    const {file} = form

    if (file && file[0] && file[0].value) {
      const filename = file[0].value.name
      console.log(file[0].value)
      this.setState({report_file: filename})
    }
  }

  handleChangeFile(e) {

    // this.formDispatch(actions.change('newProject.file', e.target.files[0]))
    this.setState({file: e.target.files[0], report_file: e.target.files[0].name})
  }


	handleSubmit(values) {
    const { file, name } = values

    if ( file && file[0] && file[0].name ) {
      const theFile = this.state.file
      let formData = new FormData()
      formData.append( "name", name )
      formData.append( "file", theFile, theFile.name )
      this.props.createProject(formData)
    } else {
      toast({ html: "Please, select a file to upload"})
    }
	}

  componentWillUnmount() {
    this.props.resetForm()
    this.props.resetErrors()
  }

	render() {
    if ( !is_validating() && !is_logged_on() ) {
      return <Redirect to="/" />
    }

    if (!is_logged_on()) {
      return (
        <Loading />
      )
    }

    if ( this.props.mustRedirect ) {
      // if this is true, fetching has succeeded
      const report_id = this.props.report.id
      return <Redirect to={`/projects/${report_id}`} />
    }


		return (
			<div className="collection with-header">
				<div className="collection-header red darken-1 white-text">
					<span className="flow-text">Add New Project</span>
					<i className="material-icons right">settings_input_composite</i>
				</div>

				<LocalForm
					className="collection-item"
					model="newProject"
          getDispatch={dispatch => this.attachDispatch(dispatch)}
          onUpdate={this.handleUpdate.bind(this)}
					onSubmit={this.handleSubmit.bind(this)}
				>

					<div className="section">
						<div className="input-field">
							<label htmlFor="thename" >At first give a name to your Project</label>
							<Control.text id="thename" model= "newProject.name" required/>
						</div>
					</div>

          <div className="section">
            <div>
              <label htmlFor="theurl">Select Spreadsheet (xls, xlsx, xlsm, ods)</label>
            </div>
            <div>
              <a className="btn mr-10" href='' onClick={e=>{
                e.preventDefault()
                document.getElementById('newProjectFile').click()
              }}>FILE...</a>
              <span style={{color:'#9e9e9e'}}>{this.state.report_file}</span>
              <Control.file id="newProjectFile" model="newProject.file" className="hide" onChange={this.handleChangeFile.bind(this)}/>
            </div>
          </div>

					<div className="section">
						<button type="submit" className="btn red darken-1 waves-effect waves-light">Next <i className="material-icons right">navigate_next</i></button>
					</div>
				</LocalForm>
        <Errors errors={this.props.errors}/>

			</div>
		)
	}
}

const NewProject = connect(mapStateToProps, mapDispatchToProps)(ConnectedNewProject);

export default NewProject;



// WEBPACK FOOTER //
// ./src/js/components/NewProject.js